<footer *ngIf="!seen" class="cookie-consent">
    <div class="container">
        <div>
            <p><span [translate]="'cookie_consent.text'"></span><br /></p>
            <ul class="list-inline">
                <li class="list-inline-item">
                    <a [translate]="'common.cookie_policy2'" [routerLink]="['/cookiePolicy']"></a>
                </li>
                <li [translate]="'common.conjunctive_text2'" class="list-inline-item"></li>
                <li class="list-inline-item">
                    <a [translate]="'common.privacy_policy2'" [routerLink]="['/privacyPolicy']"></a>
                </li>
                <li class="list-inline-item">|&nbsp;&nbsp;<a [translate]="'cookie_consent.accept'" href="#" (click)="dismiss($event)"></a></li>
            </ul>
        </div>
    </div>
</footer>
